import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  FormField,
  FormGroup,
  Form,
  Button,
  Input
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardTriggerDischargeInterfaceUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        id="CardTriggerDischargeInterfaceUX-div-0"
        style={{width: "calc(-180px + 100vw)", height:"100%",padding:"10px"}}>
        <div
          className="ui form"
          id="CardTriggerDischargeInterfaceUX-div-46"
          style={{padding: "10px 5px 15px", marginBottom: "-10px"}}>
          
          <Form
            id="CardTriggerDischargeInterfaceUX-Form-54">
            <FormGroup
              id="CardTriggerDischargeInterfaceUX-FormGroup-55"
              style={{ marginBottom: "0px"}}>
              <FormField
                id="CardTriggerDischargeInterfaceUX-FormField-63"
                width={2}>
                <label
                  id="CardTriggerDischargeInterfaceUX-label-74">
                  {props.languageUX === "en" ? "Creation Date" : "วันที่สร้าง"}
                </label>
              </FormField>
              <FormField
                id="CardTriggerDischargeInterfaceUX-FormField-64"
                width={2}>
                <label
                  id="CardTriggerDischargeInterfaceUX-label-73">
                  {props.languageUX === "en" ? "HN" : "HN"}
                </label>
              </FormField>
              <FormField
                id="CardTriggerDischargeInterfaceUX-FormField-65"
                width={2}>
                <label
                  id="CardTriggerDischargeInterfaceUX-label-72">
                  {props.languageUX === "en" ? "Admit Ward" : "แผนกรับเข้า"}
                </label>
              </FormField>
              <FormField
                id="CardTriggerDischargeInterfaceUX-FormField-66"
                width={2}>
                <label
                  id="CardTriggerDischargeInterfaceUX-label-71">
                  {props.languageUX === "en" ? "Discharge Ward" : "ห้องผู้ป่วยปล่อยตัว"}
                </label>
              </FormField>
              <FormField
                id="CardTriggerDischargeInterfaceUX-FormField-67"
                width={2}>
                <label
                  id="CardTriggerDischargeInterfaceUX-label-70">
                  {props.languageUX === "en" ? "Physicians" : "แพทย์"}
                </label>
              </FormField>
              <FormField
                id="CardTriggerDischargeInterfaceUX-FormField-68"
                width={2}>
                <label
                  id="CardTriggerDischargeInterfaceUX-label-69">
                  {"\u00A0"}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardTriggerDischargeInterfaceUX-FormGroup-56">
              <FormField
                id="CardTriggerDischargeInterfaceUX-FormField-57"
                width={2}>
                <div
                  id="CardTriggerDischargeInterfaceUX-div-80"
                  style={{ width: "100%" }}>
                  
                  <DateTextBox
                    id="CardTriggerDischargeInterfaceUX-DateTextBox-88"
                    onChange={props.onChangeDate}
                    value={props.searchDischarge?.createdDate}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardTriggerDischargeInterfaceUX-FormField-58"
                width={2}>
                <div
                  id="CardTriggerDischargeInterfaceUX-div-79"
                  style={{ width: "100%" }}>
                  
                  <Input
                    id="CardTriggerDischargeInterfaceUX-Input-85"
                    name="hn"
                    onChange={props.onChangeData}
                    value={props.searchDischarge?.hn || ""}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardTriggerDischargeInterfaceUX-FormField-59"
                width={2}>
                <div
                  id="CardTriggerDischargeInterfaceUX-div-78"
                  style={{ width: "100%" }}>
                  
                  <Input
                    id="CardTriggerDischargeInterfaceUX-Input-86"
                    name="admitWard"
                    onChange={props.onChangeData}
                    value={props.searchDischarge?.admitWard || ""}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardTriggerDischargeInterfaceUX-FormField-60"
                width={2}>
                <div
                  id="CardTriggerDischargeInterfaceUX-div-77"
                  style={{ width: "100%" }}>
                  
                  <Input
                    id="CardTriggerDischargeInterfaceUX-Input-87"
                    name="dischargeWard"
                    onChange={props.onChangeData}
                    value={props.searchDischarge?.dischargeWard || ""}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardTriggerDischargeInterfaceUX-FormField-61"
                width={2}>
                <div
                  id="CardTriggerDischargeInterfaceUX-div-76"
                  style={{ width: "100%" }}>
                  
                  <div
                    id="CardTriggerDischargeInterfaceUX-div-89">
                    {props.doctorSearchBox}
                  </div>
                </div>
              </FormField>
              <FormField
                id="CardTriggerDischargeInterfaceUX-FormField-62"
                width={2}>
                <div
                  id="CardTriggerDischargeInterfaceUX-div-75"
                  style={{ width: "100%", display: "flex" }}>
                  
                  <div
                    id="CardTriggerDischargeInterfaceUX-div-81"
                    style={{ margin: "0px 20px" }}>
                    
                    <div
                      id="CardTriggerDischargeInterfaceUX-div-83">
                      {props.searchButton}
                    </div>
                  </div>
                  <div
                    id="CardTriggerDischargeInterfaceUX-div-82">
                    
                    <Button
                      color="orange"
                      id="CardTriggerDischargeInterfaceUX-Button-84"
                      onClick={props.onClearFilter}>
                      {props.languageUX === "en" ? "Clear" : "ล้างหน้าจอ"}
                    </Button>
                  </div>
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <div
          id="CardTriggerDischargeInterfaceUX-div-2">
          
          <Table
            className="--rt-tbody-overflow-y-hidden"
            columns={props.tableHeaders}
            data={props.dischargeInterfaceList}
            id="CardTriggerDischargeInterfaceUX-Table-3"
            minRows="5"
            onPageChange={props.onPageChange}
            onPageSizeChange={props.onPageSizeChange}
            page={props.paginatedItems?.page || 0}
            pageSize={props.paginatedItems?.pageSize || 0}
            pages={Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)}
            style={{ height: "calc(95vh - 14.5rem)"}}>
          </Table>
        </div>
        <div
          className="ui form"
          id="CardTriggerDischargeInterfaceUX-div-52"
          style={{ marginTop: "20px" }}>
          
          <FormGroup
            id="CardTriggerDischargeInterfaceUX-FormGroup-32"
            inline={true}
            style={{ display: "flex", justifyContent: "flex-end" }}>
            <FormField
              id="CardTriggerDischargeInterfaceUX-FormField-13">
              <div
                id="CardTriggerDischargeInterfaceUX-div-50">
                {props.addButton}
              </div>
            </FormField>
            <FormField
              id="CardTriggerDischargeInterfaceUX-FormField-33">
              <div
                id="CardTriggerDischargeInterfaceUX-div-51">
                {props.editButton}
              </div>
            </FormField>
          </FormGroup>
        </div>
      </div>
    )
}


export default CardTriggerDischargeInterfaceUX

export const screenPropsDefault = {}

/* Date Time : Wed Oct 01 2025 12:48:09 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"calc(-180px + 100vw)\", height:\"100%\",padding:\"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-div-2"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 3,
      "name": "Table",
      "parent": 2,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "columns": {
          "type": "code",
          "value": "props.tableHeaders"
        },
        "data": {
          "type": "code",
          "value": "props.dischargeInterfaceList"
        },
        "headers": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-Table-3"
        },
        "keys": {
          "type": "value",
          "value": ""
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "onPageChange": {
          "type": "code",
          "value": "props.onPageChange"
        },
        "onPageSizeChange": {
          "type": "code",
          "value": "props.onPageSizeChange"
        },
        "page": {
          "type": "code",
          "value": "props.paginatedItems?.page || 0"
        },
        "pageSize": {
          "type": "code",
          "value": "props.paginatedItems?.pageSize || 0"
        },
        "pages": {
          "type": "code",
          "value": "Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"calc(95vh - 14.5rem)\"}"
        },
        "widths": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormField",
      "parent": 32,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-FormField-13"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "FormGroup",
      "parent": 52,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-FormGroup-32"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\" }"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "FormField",
      "parent": 32,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-FormField-33"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-div-46"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 5px 15px\", marginBottom: \"-10px\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "code",
          "value": "props.addButton"
        },
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-div-50"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "div",
      "parent": 33,
      "props": {
        "children": {
          "type": "code",
          "value": "props.editButton"
        },
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-div-51"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-div-52"
        },
        "style": {
          "type": "code",
          "value": "{ marginTop: \"20px\" }"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "Form",
      "parent": 46,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-Form-54"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "FormGroup",
      "parent": 54,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-FormGroup-55"
        },
        "style": {
          "type": "code",
          "value": "{ marginBottom: \"0px\"}"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "FormGroup",
      "parent": 54,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-FormGroup-56"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "FormField",
      "parent": 56,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-FormField-57"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "FormField",
      "parent": 56,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-FormField-58"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "FormField",
      "parent": 56,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-FormField-59"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "FormField",
      "parent": 56,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-FormField-60"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 61,
      "name": "FormField",
      "parent": 56,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-FormField-61"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "FormField",
      "parent": 56,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-FormField-62"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "FormField",
      "parent": 55,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-FormField-63"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "FormField",
      "parent": 55,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-FormField-64"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "FormField",
      "parent": 55,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-FormField-65"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "FormField",
      "parent": 55,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-FormField-66"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 67,
      "name": "FormField",
      "parent": 55,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-FormField-67"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 68,
      "name": "FormField",
      "parent": 55,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-FormField-68"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 69,
      "name": "label",
      "parent": 68,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-label-69"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "label",
      "parent": 67,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์",
          "valueEN": "Physicians"
        },
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-label-70"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "label",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": "ห้องผู้ป่วยปล่อยตัว",
          "valueEN": "Discharge Ward"
        },
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-label-71"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "label",
      "parent": 65,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนกรับเข้า",
          "valueEN": "Admit Ward"
        },
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-label-72"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 73,
      "name": "label",
      "parent": 64,
      "props": {
        "children": {
          "type": "value",
          "value": "HN",
          "valueEN": "HN"
        },
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-label-73"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 74,
      "name": "label",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่สร้าง",
          "valueEN": "Creation Date"
        },
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-label-74"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 75,
      "name": "div",
      "parent": 62,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-div-75"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"flex\" }"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": null,
      "id": 76,
      "name": "div",
      "parent": 61,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-div-76"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": null,
      "id": 77,
      "name": "div",
      "parent": 60,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-div-77"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": null,
      "id": 78,
      "name": "div",
      "parent": 59,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-div-78"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "div",
      "parent": 58,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-div-79"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "div",
      "parent": 57,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-div-80"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": null,
      "id": 81,
      "name": "div",
      "parent": 75,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-div-81"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 20px\" }"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "div",
      "parent": 75,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-div-82"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 83,
      "name": "div",
      "parent": 81,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchButton"
        },
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-div-83"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "Button",
      "parent": 82,
      "props": {
        "children": {
          "type": "value",
          "value": "ล้างหน้าจอ",
          "valueEN": "Clear"
        },
        "color": {
          "type": "value",
          "value": "orange"
        },
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-Button-84"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClearFilter"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 85,
      "name": "Input",
      "parent": 79,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-Input-85"
        },
        "name": {
          "type": "value",
          "value": "hn"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchDischarge?.hn || \"\""
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 86,
      "name": "Input",
      "parent": 78,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-Input-86"
        },
        "name": {
          "type": "value",
          "value": "admitWard"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchDischarge?.admitWard || \"\""
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 87,
      "name": "Input",
      "parent": 77,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-Input-87"
        },
        "name": {
          "type": "value",
          "value": "dischargeWard"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchDischarge?.dischargeWard || \"\""
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 88,
      "name": "DateTextBox",
      "parent": 80,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-DateTextBox-88"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDate"
        },
        "value": {
          "type": "code",
          "value": "props.searchDischarge?.createdDate"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 89,
      "name": "div",
      "parent": 76,
      "props": {
        "children": {
          "type": "code",
          "value": "props.doctorSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardTriggerDischargeInterfaceUX-div-89"
        }
      },
      "seq": 89,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": true,
  "name": "CardTriggerDischargeInterfaceUX",
  "project": "CLM CU",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
